import { QAcceptNewOffer } from "./QAcceptNewOffer";
import { QDeclineNewOffer } from "./QDeclineNewOffer";
import { QCashOutBet } from "./QCashOutBet";
export const OpenBetsQueryBuilder = {
    acceptNewOffer: QAcceptNewOffer,
    declineNewOffer: QDeclineNewOffer,
    cashOutBet: QCashOutBet
};
//# sourceMappingURL=index.js.map